'use strict';

import React from 'react'

import Layout from '@Layout/BackOffice'

export default class NotAllowedPage extends React.Component
{
	componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		var form =
		(
			<div className="page-form-container">

				<div className="o-content">

					<div className="c-form">

						<div className="c-title c-title--form">
							<h2 className="c-title__txt">Accès refusé</h2>
						</div>

						<div className="c-form-message c-form-message--red u-no-margin-bottom">
							<div className="c-form-message__content">
								Vous ne pouvez pas accéder à cette page.
							</div>
						</div>

					</div>

				</div>

			</div>
		);

		var output =
		(
			<Layout history={ props.history } page_title="Accès refusé">

				<div className="page-content">

					<div className="page-form-container">

						{ form }

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}